import DamageStatusHelper from "./damage-status-helper";


const DamageHelpers = {
    Status         : DamageStatusHelper
};

export default DamageHelpers;